import React from "react";
import styled from "styled-components";
import FormattedText, { TextNodeType } from "../../FormattedText/FormattedText";

export interface PrimaryButtonProps {
  children?: React.ReactNode;
  text?: TextNodeType;
  onClick?: () => void;
  fontSize?: number;
  block?: boolean;
  disabled?: boolean;
}

const StyledButton = styled.button<{ fontSize: number; block: boolean }>`
  background: linear-gradient(
    135deg,
    rgba(83, 178, 254, 1) 0%,
    rgba(6, 90, 243, 1) 100%
  );
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;

  /* Dynamic sizing based on fontSize and block props using em units */
  font-size: ${(props) => props.fontSize}px;
  height: 2.75em;
  padding: 0.75em 16px;
  min-width: 120px;
  width: ${(props) => (props.block ? "100%" : "auto")};

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`;

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  text,
  onClick,
  fontSize = 16,
  block = false,
  disabled = false,
}) => {
  return (
    <StyledButton
      onClick={onClick}
      fontSize={fontSize}
      block={block}
      disabled={disabled}
    >
      {text ? <FormattedText value={text} /> : children}
    </StyledButton>
  );
};

export default PrimaryButton;
